function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var s = Object.defineProperty,
    f = Object.defineProperties;
var i = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty,
    h = Object.prototype.propertyIsEnumerable;

var t = function t(m, e, o) {
  return e in m ? s(m, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : m[e] = o;
},
    a = function a(m, e) {
  for (var o in e || (e = {})) {
    c.call(e, o) && t(m, o, e[o]);
  }

  if (r) {
    var _iterator = _createForOfIteratorHelper(r(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        h.call(e, o) && t(m, o, e[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return m;
},
    p = function p(m, e) {
  return f(m, i(e));
};

import n, { forwardRef as b } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/ThumbsUp.mjs";
var u = b(function (m, e) {
  return /* @__PURE__ */n.createElement(d, p(a({
    ref: e
  }, m), {
    weights: l
  }));
});
u.displayName = "ThumbsUp";
export { u as ThumbsUp };